export var EFormStatus;

(function (EFormStatus) {
  EFormStatus["QuestionEnter"] = "questionEnter";
  EFormStatus["QuestionEdited"] = "questionEdited";
  EFormStatus["QuestionSubmitted"] = "questionSubmitted";
})(EFormStatus || (EFormStatus = {}));